export const getLoggedUser = (state) => state.UserLogin.loggedUser
